import { getConfig, getInterceptors } from '@goparrot-dashboard-api/shared';
import { UserFacade, UserImportFacade } from '@goparrot/customer-sdk';
import { LoyaltyApiMerchantFacade } from '@goparrot/loyalty-sdk';

export const userFacade: UserFacade = new UserFacade(getConfig('customers'), getInterceptors());

export const loyaltyMerchantFacade = new LoyaltyApiMerchantFacade(getConfig('loyalty'), getInterceptors());

export const userImportFacade = new UserImportFacade(getConfig('customers'), getInterceptors());
